import { localDateOf, localTimeOf, zonedIso } from '../../bookings/lib/time';

/** An instant as a `datetime-local` input's value, in the organisation's zone. */
export function toLocalInput(iso: string | null | undefined, tz: string): string {
  if (!iso) return '';
  return `${localDateOf(iso, tz)}T${localTimeOf(iso, tz)}`;
}

/** A `datetime-local` value, read in the organisation's zone, as ISO with the offset; null when empty. */
export function fromLocalInput(value: string, tz: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) return null;
  return zonedIso(value.slice(0, 10), value.slice(11, 16), tz);
}
